import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';

import { dismissWageRateAlert } from 'actions/notifications';

import { toI18n } from 'util/i18n';
import { browserHistory } from 'util/router';

import AlertsListItem from '../AlertsListItem';

type MissedWageRateProps = {
  item: ImmutableMap<string, any>;
  closeDrawer: () => void;
};

const MissedWageRate = ({
  item,
  closeDrawer,
  ...rest
}: MissedWageRateProps) => {
  const dispatch = useDispatch();

  const handleEdit = useCallback(() => {
    closeDrawer();
    const url = `/team/${item.get('user_id')}/job_details?wageAlert=true`;
    browserHistory.push(url);
  }, [closeDrawer, item]);

  const handleDismiss = useCallback(() => {
    dispatch(dismissWageRateAlert(item));
  }, [dispatch, item]);

  const formattedFullName = `${item.get('first_name')} ${item.get(
    'last_name'
  )}`;

  return (
    <AlertsListItem
      desc={toI18n('notifications.alerts.wage_rate.desc', {
        props: { name: formattedFullName },
      })}
      onEdit={handleEdit}
      onDismiss={handleDismiss}
      item={item}
      {...rest}
    />
  );
};

export default React.memo(MissedWageRate);
